export default __webpack_public_path__ + "static/media/pictogramBeaconAppreciation40.42f6bbb8.svg";